module.exports = __webpack_public_path__ + "media/luxury-2026/waterfront-kitchen-960-707a1b6c.jpg";